import * as React from 'react';
import { Badge, Button, Card, Col, Collapse, Form, Row, Select, Space, Switch, Table, Tag, Tooltip, Input, List } from 'antd';
import { ShortDateStringForUser } from '../../../utilites/dateTimeHelper';
import { DateFormat } from '../../../constants/dateFormat';
import { useHistory } from 'react-router';
import "../UserDetail.scss";
import { CompanyUserProfile } from '../../../models/company-user-profile-interface';
import Text from 'antd/lib/typography/Text';
import { getSSOAccessTypeDescription } from '../../../constants/ssoAccessType';
import { useState } from 'react';
import ChangeUserTypeModal from '../modals/ChangeUserTypeModal';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';

const { Panel } = Collapse;

type Props = {
    profile: CompanyUserProfile;
    onActiveChange: Function;
  }
  
const UserCompanyCard: React.FC<Props> = ({ 
    profile,
    onActiveChange
  }) => {
  const [showUserTypeModal, setShowUserTypeModal] = useState<boolean>(false);
  const useDashboardQuery = CustomerServiceQueries.useUserDashboards(profile?.userId, profile?.companyId);
  const history = useHistory();

  
  const columns: any = [
    {
      title: 'Group Name',
      dataIndex: 'companyCommittee',
      key: 'name',
      render: (_, record) => record.companyCommittee.name
    },
    {
        title: 'Type',
        dataIndex: 'companyCommittee.groupTypeName',
        key: 'groupType',
        render: (_, record) => record.companyCommittee.groupTypeName
    },
    {
      title: 'Role',
      dataIndex: 'committeeRole',
      key: 'role',
      render: (_, record) => !!record.committeeRole && record.committeeRole.name
    },
    {
      title: 'Admin',
      dataIndex: 'committeeAdmin',
      key: 'admin',
      render: (_, record) => record.committeeAdmin ? "Yes" : null
    }
  ];

  const roleName = ():string => {
      if(profile.roleId === 1) {
          return profile.committeeUsers.some(x => x.committeeAdmin) ? "Committee Admin" : profile.role.name
      } else {
          return profile.role.name
      }
  }

  return <Card
            key={`company-${profile.companyId}`}
            className="user-detail-card"
            title={<Row>
                    <Col span={24}><span className="primary-text" style={{cursor: 'pointer'}} onClick={e => history.push(`/admin/company/${profile.companyId}`)}>{profile.companyName}</span>
                    {!profile.companyEnabled && <Text type='secondary' style={{fontSize: 12}} italic>&nbsp;(Disabled)</Text>}
                    </Col>
                    <Col><Space>{profile.fullName}
                    {!!profile.title && 
                        <Text type='secondary'>{profile.title}</Text>
                    }</Space></Col>
                </Row>}
            bordered={false}
            style={{opacity: profile.companyEnabled ? 1.0 : 0.8}}
            extra={
                <Space>
                <Tag>Notified {ShortDateStringForUser(profile.notificationDate ?? '', DateFormat.MonthDayYear)}</Tag>
                <Button
                  type="text"
                  style={{padding: 0}}
                  onClick={() => {
                    setShowUserTypeModal(true);
                  }}
                >
                  <Badge count={roleName()} style={{backgroundColor: "#6c0cc6"}}/>
                </Button>
                <Switch defaultChecked={profile.active} checkedChildren="Active" unCheckedChildren="Inactive" onChange={(checked) => onActiveChange(checked, profile.companyId)} disabled={!profile.companyEnabled} />
                {profile.companySamlConfigured && 
                  <>
                    {profile.companySamlEnabled ? 
                      <Badge count={getSSOAccessTypeDescription(profile.ssoAccessType)} style={{backgroundColor: "#52c41a"}}/> :
                      <Tooltip overlay={`Single Sign-On is disabled for ${profile.companyName}`}>
                        <Badge count={getSSOAccessTypeDescription(profile.ssoAccessType)} style={{backgroundColor: "#52c41a"}}/>
                      </Tooltip>}
                  </>}
                </Space>
            }
            >
                <Collapse bordered={false}>
                  <Panel showArrow={profile.committeeUsers.length > 0} header={profile.committeeUsers.length > 0 ? `${profile.committeeUsers.length} group${profile.committeeUsers.length !== 1 ? "s":""}` : "Not a member of any groups"} key={`groups-${profile.companyId}`}>
                      <Table
                          columns={columns}
                          dataSource={profile.committeeUsers.map(x => ({...x, key: x.companyCommitteeId}))}
                          pagination={false}
                          size="small"
                      />
                  </Panel>
                  <Panel
                    collapsible={useDashboardQuery?.data?.filter(x => x.name != "Default Dashboard")?.length > 0 ? "header" : "disabled"}
                    showArrow={useDashboardQuery?.data?.filter(x => x.name != "Default Dashboard")?.length > 0}
                    header={useDashboardQuery?.data?.filter(x => x.name != "Default Dashboard")?.length > 0 ? "Assigned Member Dashboards" : "No Dashboard Assignments (show all widgets)"}
                    key="dashboards"
                  >
                    <List
                      dataSource={useDashboardQuery?.data ?? []}
                      loading={useDashboardQuery?.isLoading}
                      renderItem={(item) => <List.Item key={`${profile?.companyId}-${item.id}`}>{item?.name}</List.Item>}
                    />
                  </Panel>
                </Collapse>
                <ChangeUserTypeModal
                  profile={profile}
                  setIsVisible={setShowUserTypeModal}
                  isVisible={showUserTypeModal}
                />
                </Card>
}

export default UserCompanyCard;